var _ellipse, _path, _ellipse2, _path2, _ellipse3, _path3, _ellipse4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLogoPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.0949,
    cy: 11.0836,
    rx: 3.15989,
    ry: 3.17245,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93531 7.91063L11.19 7.91063L7.93531 11.2417L7.93531 7.91063Z",
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.15066,
    cy: 3.91641,
    rx: 3.15989,
    ry: 3.17245,
    transform: "rotate(180 4.15066 3.91641)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3103 7.08937L4.05561 7.08937L7.3103 3.75829L7.3103 7.08937Z",
    fill: "currentColor"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.12979,
    cy: 10.99,
    rx: 3.15989,
    ry: 3.17246,
    transform: "rotate(90 4.12979 10.99)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30226 7.82984L7.30226 11.0845L3.97118 7.82984L7.30226 7.82984Z",
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1895,
    cy: 3.90261,
    rx: 3.15989,
    ry: 3.17245,
    transform: "rotate(-90 11.1895 3.90261)",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01708 7.06274L8.01708 3.80805L11.3482 7.06274L8.01708 7.06274Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoPlain);
export default __webpack_public_path__ + "static/media/ic_logo_plain.4f83dc073941c704363a23245f161590.svg";
export { ForwardRef as ReactComponent };